
import { LayoutDashboard } from "lucide-react";

export const professionalItems = [
  { 
    icon: LayoutDashboard,
    label: "Dashboard",
    items: [
      { icon: LayoutDashboard, label: "Dashboard professionnel", path: "/professional" }
    ]
  }
];
